import { Grid, Typography } from "@material-ui/core";
import * as React from "react";
import AccountDisplay from "./AccountDisplay";
import "./App.css";
import { AccountSum } from "./app/AccountAnalyze";
import { AccountMovement } from "./db/AccountMovement";

interface Props {
  result: AccountSum[];
}

export default class AccountData extends React.Component<Props> {
  public state = {
    hoverRow: null as AccountMovement | null,
    selectedRows: [] as AccountMovement[]
  };
  public hoverRow = (m: AccountMovement | null) => {
    this.setState({ hoverRow: m });
  };
  public selectRow = (m: AccountMovement) => {
    if (this.state.selectedRows.includes(m)) {
      this.setState({ selectedRows: this.state.selectedRows.filter(a => a !== m) });
    } else {
      this.setState({ selectedRows: this.state.selectedRows.concat([m]) });
    }
  };

  public render() {
    const mainAccounts = this.props.result.filter(a => a.primary);
    const otherAccounts = this.props.result.filter(a => !a.primary);

    return (
      <Typography component="div">
        <Grid container spacing={8}>
          {mainAccounts.map((a, i) => (
            <Grid item key={i}>
              <AccountDisplay account={a} onHover={this.hoverRow} onSelect={this.selectRow} {...this.state} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={8}>
          {otherAccounts.map((a, i) => (
            <Grid item key={i}>
              <AccountDisplay account={a} onHover={this.hoverRow} onSelect={this.selectRow} {...this.state} />
            </Grid>
          ))}
        </Grid>
      </Typography>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AccountData.tsx